import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.isMobile())
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        ($setup.error)
          ? (_openBlock(), _createBlock($setup["ErrorComponent"], {
              key: 0,
              error: $setup.error,
              retriable: $setup.error === $setup.Errors.Unknown
            }, null, 8, ["error", "retriable"]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              ($setup.step == $setup.Steps.Guidelines)
                ? (_openBlock(), _createBlock($setup["PhotoGuidelines"], { key: 0 }))
                : ($setup.step == $setup.Steps.Accept)
                  ? (_openBlock(), _createBlock($setup["PhotoAccept"], { key: 1 }))
                  : ($setup.step == $setup.Steps.AcceptDocument)
                    ? (_openBlock(), _createBlock($setup["DocumentAccept"], { key: 2 }))
                    : _createCommentVNode("", true)
            ], 64))
      ], 64))
    : (_openBlock(), _createBlock($setup["ConnectDevice"], { key: 1 }))
}